import { FlexBox } from "@brg/ui";
import styled from "styled-components";

export const Wrapper = styled(FlexBox)`
    flex-flow: column;

    input ~ .competition-checkbox {
        width: 24px;
        height: 24px;
        background: ${({theme}) => theme.competition.input.checkbox.bg} !important;
        border-color: ${({theme}) => theme.competition.input.checkbox.border} !important;
        
        svg {
            path {
                fill: ${({theme}) => theme.competition.input.checkbox.icon};
            }
        }
    }

    .books-label {
        white-space: nowrap;
        user-select: none;
        margin-bottom: 0;
    }
`;import { FlexBox } from "@brg/ui";
import styled from "styled-components";

export const Wrapper = styled(FlexBox)`
    flex-flow: column;

    input ~ .competition-checkbox {
        width: 24px;
        height: 24px;
        background: ${({theme}) => theme.competition.input.checkbox.bg} !important;
        border-color: ${({theme}) => theme.competition.input.checkbox.border} !important;
        
        svg {
            path {
                fill: ${({theme}) => theme.competition.input.checkbox.icon};
            }
        }
    }

    .books-label {
        white-space: nowrap;
        user-select: none;
        margin-bottom: 0;
    }
`;